import { authReducer } from './reducers/authReducer'
import { createStore } from 'redux'
import { persistStore,persistReducer } from 'redux-persist'
import  storage from 'redux-persist/lib/storage'

const persistConfig = {
    key:'root',
    storage
}
const persistedAuthReducer = persistReducer(persistConfig,authReducer)

const store = createStore(persistedAuthReducer)
export const persistor = persistStore(store)

export default store;